import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Styles/style.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Forgetpassword from './Auth/Forgetpassword/Forgetpassword';
import Login from './Auth/Login/Login';
import Verification from './Auth/Verification/Verification';
import ForgetVerifiction from './Auth/ForgetVerifiction/ForgetVerifiction';
import Newpassword from './Auth/Newpassword/Newpassword';
import Registration from './Auth/Registration/Registration';
import Mfauthentication from './Auth/Mfauthentication/Mfauthentication';
import MultiFactor from './Auth/MultiFactor/MultiFactor';
import { Provider } from 'react-redux';
import Notfound from './Pages/Notfound/NotFound';
import store from './Redux/Store/Store';
import App from './App';
import Pages from './Routes/Pages';
import VarifyLogin from './Auth/LoginVarification/LoginVarification';
import PaymentSuccess from './Auth/PaymentSuccess/PaymentSuccess';
import ResetPassword from './Auth/ResetPassword/ResetPassword';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';

const router = createBrowserRouter([
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '/login-varify',
        element: <VarifyLogin />,
    },
    {
        path: '/mfauthentication',
        element: <Mfauthentication />,
    },
    // {
    //   path: "/multi-factor",
    //   element: <MultiFactor />,
    // },
    {
        path: '/multi-factor',
        element: <MultiFactor />,
    },
    {
        path: '/new-password',
        element: <ResetPassword />,
    },
    {
        path: '/signup',
        element: <Registration />,
    },
    {
        path: '/forgotPassword',
        element: <Forgetpassword />,
    },
    {
        path: '/verification',
        element: <Verification />,
    },
    {
        path: '/newPassword',
        element: <Newpassword />,
    },
    {
        path: '/forgetVerifiction',
        element: <ForgetVerifiction />,
    },
    {
        path: '/success',
        element: <PaymentSuccess />,
    },
    {
        path: '*',
        element: <Notfound />,
    },
    {
        path: '/',
        element: <App />,
        children: Pages,
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <GTMProvider
        state={{
            id: 'GTM-59JBF9TJ',
        }}>
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
    </GTMProvider>
    // </React.StrictMode>
);

reportWebVitals();
